module.exports = __webpack_public_path__ + "static/media/ns_xuan_shan.bf62429d.png";